import styled from "styled-components"

type Props = {
    children: string | JSX.Element
    shadowColor: "black" | "white" | "red"
    bodyColor: "black" | "white" | "red"
    onClick?: (param: any) => void 
    width?: number
    height?: number
    padding?: number[]
}

const Parallelogram = (props: Props) => {
    return (
        <ParallelogramStyle 
            onClick={props.onClick}
            style={{ width: `${props.width || 320}px`, height: `${props.height || 40}px`, cursor: props.onClick ? "pointer" : "default" }}
        >
            <div 
                className={`parallelogram-shadow ${props.shadowColor}`}
                style={{ width: `${props.width || 320}px`, height: `${props.height || 40}px` }}
            >
            </div>
            <div 
                className={`parallelogram-body ${props.bodyColor}`}
                style={{ 
                    width: `${props.width || 320}px`, 
                    height: `${props.height || 40}px`,
                    paddingTop: `${props.padding && props.padding.length > 0 ? props.padding[0] : 10}px`,
                    paddingRight: `${props.padding && props.padding.length > 1 ? props.padding[1] : 40}px`,
                    paddingBottom: `${props.padding && props.padding.length > 2 ? props.padding[2] : 0}px`,
                    paddingLeft: `${props.padding && props.padding.length > 3 ? props.padding[3] : 40}px`
                }}
            >
                {props.children}
            </div>
        </ParallelogramStyle>
    )
}

export default Parallelogram

const ParallelogramStyle = styled.div`
position: relative;
margin: auto;
    .parallelogram-body {
        font-weight: bold;
        position: relative;
        clip-path: polygon(0% 100%, 10% 0%, 100% 0%, 90% 100%);
    }
    .parallelogram-shadow {
        position: absolute;
        z-index: 0;
        top: 10px;
        left: 5px;
        clip-path: polygon(0% 100%, 10% 0%, 100% 0%, 90% 100%);
    }
    .red {
        background-color: red;
        color: white;
    }
    .black {
        background-color: black;
        color: white;
    }
    .white {
        background-color: white;
        color: black;
    }
`